
  export default {
    props: { numberOfPosts: { type: Number, default: 5 } },
    data () { return { fbReady: false }; },
    mounted () {
      if (this.$config.environment !== 'production') return;
      this.fbInit(document, 'script', 'facebook-jssdk');
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: process.env.FACEBOOK_APP_ID,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v10.0'
        });
        this.fbReady = true;
      };
    },
    methods: {
      fbInit (d, s, id) {
        if (d.getElementById(id)) {
          this.fbReady = true;
          return;
        }
        let fjs = d.getElementsByTagName(s)[0];
        let js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_GB/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      }
    }
  };
